export class TablesRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async upsertTables(rows) {
        if (rows.length === 0)
            return;
        // Portable update-then-insert pairs (minSdk 26 SQLite has no upsert).
        await this.driver.batch(rows.flatMap((t) => [
            {
                sql: 'UPDATE restaurant_tables SET code = ?, seats = ?, section = ?, is_active = ? WHERE id = ?',
                params: [t.code, t.seats, t.section, t.isActive ? 1 : 0, t.id],
            },
            {
                sql: `INSERT INTO restaurant_tables (id, code, seats, section, is_active)
                SELECT ?, ?, ?, ?, ? WHERE (SELECT changes()) = 0`,
                params: [t.id, t.code, t.seats, t.section, t.isActive ? 1 : 0],
            },
        ]));
    }
    async listWithOccupancy() {
        const rows = await this.driver.query({
            sql: `SELECT t.*, o.id AS open_order_id
            FROM restaurant_tables t
            LEFT JOIN orders o ON o.table_id = t.id AND o.status = 'OPEN'
            WHERE t.is_active = 1
            ORDER BY t.section, t.code`,
        });
        return rows.map((r) => ({
            id: String(r.id),
            code: String(r.code),
            seats: Number(r.seats),
            section: String(r.section),
            isActive: true,
            isOccupied: r.open_order_id != null,
            openOrderId: r.open_order_id == null ? null : String(r.open_order_id),
        }));
    }
    async getById(id) {
        const rows = await this.driver.query({
            sql: 'SELECT * FROM restaurant_tables WHERE id = ?',
            params: [id],
        });
        const r = rows[0];
        if (!r)
            return null;
        return {
            id: String(r.id),
            code: String(r.code),
            seats: Number(r.seats),
            section: String(r.section),
            isActive: Number(r.is_active) === 1,
        };
    }
}
//# sourceMappingURL=tables.js.map